<template>
  <div>
    <loading :loading="isLoading">
      <b-card header="Related extract data">
        <error :error="error"/>
        <div v-if="page">
          <b-list-group flush>
            <b-list-group-item>
              <discounts title="Single-person discounts" :discounts="page.SinglePersonDiscounts"/>
            </b-list-group-item>
            <b-list-group-item>
              <loading message="Loading discounts for all residents" :loading="isLoadingSubQuery">
                <discounts v-if="pageWithAddress" title="All residents discounts" :discounts="pageWithAddress.AllResidentsDiscounts"/>
              </loading>
            </b-list-group-item>
            <b-list-group-item>
              <shbe :shbe="page.Shbe"/>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-card>
    </loading>
  </div>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'
import Shbe from '../extract_views/Shbe.vue'
import Discounts from '../extract_views/Discounts.vue'

export default {
  components: { Loading, Error, Shbe, Discounts },
  props: ['reference'],
  data() {
    return {
      isLoading: true,
      isLoadingSubQuery: true,
      page: null,
      pageWithAddress: null,
      error: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'spd_multiple_adults_shbe',
      parameters: {
        reference: this.reference,
      },
    })
    .then((page) => {
      this.page = page;
      // now grab data related to the address within the results
      if (page.SinglePersonDiscounts.length > 0) {
        let addressBids = page.SinglePersonDiscounts.map(z => `${z.address_line_1.toUpperCase()}|${z.post_code}`).toString();
        this.isLoading = false;
        return this.fetchPageWithAddress(addressBids);
      }
    })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  },

  methods: {
    fetchPageWithAddress(addressbid) {
      this.isLoadingSubQuery = true;
      const { access_token } = this.$store.state.oidcStore;
      return this.$reportingApi.renderPage('panessex', access_token, {
        pageName: 'spd_multiple_adults_shbe_with_address',
        parameters: { addressbid },
      })
      .then(page => { this.pageWithAddress = page; this.isLoadingSubQuery = false; })
      .catch(() => this.isLoadingSubQuery = false);
    },
  },
};
</script>
